import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=11ff7a20&"
import script from "./FormEdit.vue?vue&type=script&lang=js&"
export * from "./FormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ff7a20')) {
      api.createRecord('11ff7a20', component.options)
    } else {
      api.reload('11ff7a20', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=11ff7a20&", function () {
      api.rerender('11ff7a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/intimidation-form/handling/FormEdit.vue"
export default component.exports